import http from "../../services/http";
import { handleErrors } from "../../helpers/error";
import storage from "../../services/storage";
import {
  addUsersCard,
  getUsersCard,
  getUserNuveiCards,
  getUsersCardAch,
  setWhiteListedStates,
  setAllowedPaymentsProviders,
  userSavedCardsDetailsActions,
  getUsersAccountCashApp,
  getUsersAccountApprovely,
} from "../auth/getUsersCards";
import { SetGetOrderCart } from "../ui/cart";
// export const paymentApi = ({ body = {}, onSuccess, onError, onEnd }) => {
//   return async (dispatch) => {
//     try {
//       const res = await http.post({
//         url: "v1/checkout/addcard",
//         body,
//         headers: {
//           "x-auth-token": storage.get("xAuthToken"),
//         },
//       });
//       onSuccess?.(res);
//       dispatch(addUsersCard(res?.data?.data[0]?.data));
//       // console.log("resp arry ", res.data.data[0].data);
//     } catch (error) {
//       // console.log("in error=====>", error.response.message);
//       if (onError) onError(error);
//       handleErrors(error);
//     } finally {
//       if (onEnd) onEnd();
//     }
//   };
// };
export const paymentApi = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/nuvei/init",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });
      if (res?.data?.card) {
        dispatch(addUsersCard(res?.data?.card));
        onSuccess?.(res);
      } else {
        dispatch(
          userSavedCardsDetailsActions.setThreeDFingerprintingData(res?.data)
        );
        dispatch(
          firstPaymentUrl({
            body: {
              ...body,
              version: res?.data?.paymentOption?.card?.threeD?.version,
              relatedTransactionId: res?.data?.transactionId,
            },
            onSuccess: (res1) => {
              if (res1?.data?.redirect === true) {
                dispatch(
                  userSavedCardsDetailsActions.setThreeDSecureUrl(res1?.data)
                );
              } else if (res1?.data?.card) {
                dispatch(addUsersCard(res1?.data?.card));
              }

              onSuccess?.(res1);
            },
            onError: (error) => {
              onError?.(error);
            },
          })
        );
      }
      // console.log("resp arry ", res.data.data[0].data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const firstPaymentUrl = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/nuvei/payment/first",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const confirmPayment = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/checkout/",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const getOrderDetails = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/checkout/getorder",

        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      dispatch(SetGetOrderCart(res.data));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getUsersCardApi = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/nuvei/cards",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // dispatch(getUsersCard(res?.data?.cards));
      dispatch(getUsersCardAch(res?.data?.paymentMethods));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const getUsersCardApiStripe = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/payment/stripe/payment-methods",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      //stripe saved credit cards
      dispatch(getUsersCard(res?.data?.paymentMethods?.card));
      // nuvei Saved Credit Cards
      dispatch(getUserNuveiCards(res?.data?.paymentMethods?.nuveiCards));
      // Stripe CashApp Accounts
      dispatch(getUsersAccountCashApp(res?.data?.paymentMethods?.cashapp));

      // dispatch(getUsersCardAch(res?.data?.paymentMethods));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const getUsersAccountsApprovely = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/payment/approvely/methods",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      dispatch(getUsersAccountApprovely(res?.data?.paymentMethods?.ach));

      // dispatch(getUsersCardAch(res?.data?.paymentMethods));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const deleteUsersSavedCards = ({
  item,
  index,
  onSuccess,
  onError,
  onEnd,
  id,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.delete({
        url: "v1/nuvei/cards/" + id,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const deleteUsersSavedStripeCards = ({
  item,
  index,
  onSuccess,
  onError,
  onEnd,
  id,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.delete({
        url: "v1/payment/stripe/payment-methods/" + id,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// ACH
export const AchPayment = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/nuvei/payment/ach",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
// ACH Check status

export const AchAddBank = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/nuvei/add_bank",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// new API to Pay with saved ACH accounts
export const AchAddBankNew = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/checkout/saved-bank",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// cashout white listed
export const getWhiteListedStates = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/admin/whitelist_states/whitelist",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);

      const states = res?.data?.states;
      const sortByRegion = (states) => {
        // Copy the array to avoid mutating the original
        const sortedStates = [...states];

        sortedStates.sort((a, b) => {
          // Assuming 'region' is a string, adjust comparison based on your data structure
          return a.region.localeCompare(b.region);
        });

        return sortedStates;
      };
      dispatch(setWhiteListedStates(sortByRegion(states)));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const getpaymentProviderSettings = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/payment/allowed-providers",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log('res.data allowed providers' , res?.data?.data?.allowedPayment);
      dispatch(setAllowedPaymentsProviders(res?.data?.data?.allowedPayment));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
// ach payment checkout
export const confirmPaymentAch = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/nuvei/payment/ach",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
// delete ach user card
export const deleteUsersSavedCardsAch = ({
  item,
  index,
  onSuccess,
  onError,
  onEnd,
  id,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.delete({
        url: "v1/nuvei/banks/" + id,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// get order details of ach
export const getOrderDetailACH = ({ orderId, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: `v1/nuvei/ach/${orderId}`,
        headers: { 
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
         },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const addCardAndPayCashier = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/nuvei/cashier",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log("resp arry ", res.data.data[0].data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const paySavedCardStripe = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  const paymentOptionId = body?.userPaymentOptionId;

  return async (dispatch) => {
    try {
      const res = await http.post({
        url: `v1/payment/stripe/payment-intent/${paymentOptionId}`,
        body: {},
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log("resp arry ", res.data.data[0].data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getSessionKeyApprovelyCoinFlow = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  // console.log("body in addNewSquareCashAppAndPay api ", body.distributor);
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: `v1/payment/coinflow/session?gameProvider=${body?.distributor}`,
        body: {},
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log("response of session coin flow ", res.data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const addNewSquareCashAppAndPay = ({
  body,
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      // console.log(
      //   'body in addNewSquareCashAppAndPay api ',
      //   JSON.stringify(body)
      // )
      const res = await http.post({
        url: `v1/payment/square/create-payment`,
        body: body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log("response of session coin flow ", res.data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getConfigSquareCashApp = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      // console.log(
      //   'body in addNewSquareCashAppAndPay api ',
      //   JSON.stringify(body)
      // )
      const res = await http.get({
        url: `v1/payment/square/config`,
        body: body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log("response of session coin flow ", res.data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const submitGamePlatform = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: "v1/third-party/requests/cashouts",
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });
      onSuccess?.(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
